import React, { useEffect, useState, useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { AppContext } from '@thd-nucleus/app-render';
import { DELETED_ACCOUNT_MSG, ADD_CHECKING_ACCOUNT, } from '../../../constants/response-success-messages';
import { getNewPageNumber, hasNoPaymentCards } from '../../../utils/payments';
import { Pagination } from '../../shared/pagination/pagination';
import { Spinner } from '../../shared/spinner/spinner';
import { usePayments } from '../../../hooks/use-payments';
import { Alert } from '../../shared/alert/alert';
import { PaymentsHeader } from '../payments-header/payments-header';
import { CardType } from '../../../constants/payments';
import { CheckingAccountCard } from '../checking-account-card/checking-account-card';
import { TAlertStatus } from '../../../models/common/alert-messages';
import { scrollToTop } from '../../../utils/general';
import { PaymentsHeaderSecondaryButtons } from '../payments-header/payments-header-secondary-buttons';
import { NoPaymentCardsMessage } from '../../shared/no-payment-cards-message/no-payment-cards-message';
export const CheckingAccountList = () => {
    var _a;
    const [deletedCreditCardIndex, setDeletedCreditCardIndex] = useState(null);
    const { loading, checkingAccounts, paginationInfo, currentPageNumber, alertMessage, getPaymentCards, setAlertMessage, } = usePayments();
    const { channel } = useContext(ExperienceContext);
    const { instance } = useContext(AppContext);
    const isB2B = ((_a = instance === null || instance === void 0 ? void 0 : instance.customer) === null || _a === void 0 ? void 0 : _a.type) === 'b2b';
    const isMobile = channel === 'mobile';
    const totalPages = Number(paginationInfo === null || paginationInfo === void 0 ? void 0 : paginationInfo.totalPages) || 0;
    useEffect(() => {
        return () => {
            setAlertMessage(null);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleSuccess = (paymentId, message) => {
        setAlertMessage({
            paymentId,
            alertStatus: TAlertStatus.SUCCESS,
            text: message,
        });
        if (message === DELETED_ACCOUNT_MSG.message) {
            const newPage = getNewPageNumber(currentPageNumber, totalPages, isB2B
                ? paginationInfo === null || paginationInfo === void 0 ? void 0 : paginationInfo.paymentsOnCurrentPage
                : checkingAccounts === null || checkingAccounts === void 0 ? void 0 : checkingAccounts.paymentCards.length);
            // ensure user stays on the same page or on the previous page (if last payment deleted) to show delete confirmation
            onChangePage(newPage);
            return;
        }
        onChangePage(1);
    };
    const handleError = (paymentId, message) => {
        setAlertMessage({
            paymentId,
            alertStatus: TAlertStatus.ERROR,
            text: message,
        });
    };
    const onChangePage = (newPageNumber) => {
        triggerGetPaymentCards(newPageNumber);
    };
    const triggerGetPaymentCards = (pageNumber) => {
        return getPaymentCards(CardType.CHECKING_ACCOUNT, false, false, {
            page: pageNumber,
        });
    };
    const getCheckingAccountList = () => {
        var _a;
        const checkingAccountList = ((_a = checkingAccounts === null || checkingAccounts === void 0 ? void 0 : checkingAccounts.paymentCards) === null || _a === void 0 ? void 0 : _a.map((account, index) => (React.createElement("div", { key: account.paymentId, className: `sui-flex ${isMobile ? 'sui-flex-col' : ''}` },
            React.createElement(CheckingAccountCard, { key: account.paymentId, card: account, setDeletedCreditCardIndex: setDeletedCreditCardIndex, index: index, isMobile: isMobile, onActionSuccess: handleSuccess, onActionFailure: handleError }))))) || null;
        if (isMobile &&
            deletedCreditCardIndex !== null &&
            checkingAccountList !== null) {
            checkingAccountList.splice(deletedCreditCardIndex, 0, React.createElement(React.Fragment, null, successMessage));
        }
        return checkingAccountList;
    };
    const successMessage = alertMessage &&
        alertMessage.alertStatus === TAlertStatus.SUCCESS && (React.createElement("div", { className: "sui-mt-4 sm:sui-mt-0 lg:sui-mb-8" },
        React.createElement(Alert, { status: alertMessage.alertStatus, onClose: () => setAlertMessage(null) }, alertMessage.text)));
    const successAddMessage = isMobile &&
        (alertMessage === null || alertMessage === void 0 ? void 0 : alertMessage.text) === ADD_CHECKING_ACCOUNT.message && (React.createElement("div", { className: "sui-mt-4 sm:sui-mt-0 lg:sui-mb-8" },
        React.createElement(Alert, { status: alertMessage.alertStatus, onClose: () => setAlertMessage(null) }, alertMessage.text)));
    const desktopErrorMessage = !isMobile &&
        alertMessage &&
        alertMessage.alertStatus === TAlertStatus.ERROR && (React.createElement("div", { className: "lg:sui-mb-8" },
        React.createElement(Alert, { status: alertMessage.alertStatus, onClose: () => setAlertMessage(null) }, alertMessage.text)));
    return (React.createElement(React.Fragment, null,
        React.createElement(Spinner, { active: loading }),
        React.createElement(PaymentsHeader, { cardType: CardType.CHECKING_ACCOUNT, onActionFailure: handleError, onActionSuccess: handleSuccess }),
        successAddMessage,
        !isMobile && successMessage,
        desktopErrorMessage,
        React.createElement(PaymentsHeaderSecondaryButtons, { cardType: CardType.CHECKING_ACCOUNT, onActionSuccess: handleSuccess, onActionFailure: handleError }),
        hasNoPaymentCards(checkingAccounts) && (React.createElement(NoPaymentCardsMessage, { tenderType: CardType.CHECKING_ACCOUNT })),
        React.createElement("div", { className: "sui-grid sui-grid-cols-1 sui-gap-y-4 sui-gap-x-8 md:sui-grid-cols-2 2xl:sui-gap-y-16 2xl:sui-grid-cols-3" }, getCheckingAccountList()),
        totalPages > 1 && (React.createElement("div", { className: "sui-w-full sui-justify-center sui-p-5 sui-flex" },
            React.createElement(Pagination, { nPages: totalPages, onChangePage: (newPage) => {
                    onChangePage(newPage);
                    setAlertMessage(null);
                    scrollToTop();
                }, page: currentPageNumber })))));
};
